import { useCallback, useContext, useMemo } from 'react';

import { getNameExtension } from '@shared/helpers';
import { useDeleteFile } from '@widgets/Files/hooks/useDeleteFile';
import { useDeleteFolder } from '@widgets/Files/hooks/useDeleteFolder';
import { useGetFiles } from '@widgets/Files/hooks/useGetFiles';
import { useRenameFile } from '@widgets/Files/hooks/useRenameFile';
import { ContextFiles } from '@widgets/Files/model/context';

export const useModalFiles = (onHideModal: () => void) => {
    const { currentFileId, currentFolderDropdownId, currentFolderId } = useContext(ContextFiles);
    const { parsedFilesData } = useGetFiles(currentFolderId);
    const currentFileInfo = useMemo(
        () => parsedFilesData?.find((file) => file.id === currentFileId),
        [parsedFilesData, currentFileId]
    );
    const folderMutation = useDeleteFolder();
    const fileMutation = useDeleteFile();
    const renameFileMutation = useRenameFile();

    const { name } = getNameExtension(currentFileInfo?.name || '');

    const onDeleteFolder = useCallback(() => {
        folderMutation.mutate(currentFolderDropdownId);
        onHideModal();
    }, [folderMutation, onHideModal, currentFolderDropdownId]);
    const onDeleteFile = useCallback(() => {
        fileMutation.mutate(currentFileId);
        onHideModal();
    }, [fileMutation, onHideModal, currentFileId]);
    const onRenameFile = useCallback(
        (newName: string) => {
            renameFileMutation.mutate({ fileId: currentFileId, newName });
            onHideModal();
        },
        [renameFileMutation, onHideModal, currentFileId]
    );

    return { onDeleteFile, onDeleteFolder, onRenameFile, currentName: name };
};
